var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-editor", on: { keydown: _vm.catchEvents } },
    [
      _vm.editor
        ? _c(
            "bubble-menu",
            {
              class: "editable-tippy",
              attrs: { editor: _vm.editor, "tippy-options": _vm.tippyOptions },
            },
            [
              _c("div", { staticClass: "bubble-menu" }, [
                !_vm.isText
                  ? _c(
                      "div",
                      {
                        staticClass: "bubble-menu-item",
                        class: { "is-active": _vm.editor.isActive("bold") },
                        on: {
                          click: function ($event) {
                            _vm.editor.chain().focus().toggleBold().run()
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("format_bold"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isText
                  ? _c(
                      "div",
                      {
                        staticClass: "bubble-menu-item",
                        class: { "is-active": _vm.editor.isActive("italic") },
                        on: {
                          click: function ($event) {
                            _vm.editor.chain().focus().toggleItalic().run()
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("format_italic"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isText
                  ? _c(
                      "div",
                      {
                        staticClass: "bubble-menu-item",
                        class: { "is-active": _vm.editor.isActive("strike") },
                        on: {
                          click: function ($event) {
                            _vm.editor.chain().focus().toggleStrike().run()
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("strikethrough_s"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isText
                  ? _c(
                      "div",
                      {
                        staticClass: "bubble-menu-item",
                        class: {
                          "is-active": _vm.editor.isActive("underline"),
                        },
                        on: {
                          click: function ($event) {
                            _vm.editor.chain().focus().toggleUnderline().run()
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("format_underlined"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "bubble-menu-item ai-item",
                    on: { click: _vm.aiTools },
                  },
                  [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("emoji_objects"),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "actions" }, [
        _c("div", { staticClass: "left-actions" }, [
          _vm.speechRecognition
            ? _c(
                "div",
                {
                  staticClass: "action-button",
                  class: {
                    "voice-speech": _vm.speechRecognitionActive,
                  },
                  on: { click: _vm.openSpeechRecognition },
                },
                [_c("div", { staticClass: "material-icons" }, [_vm._v("mic")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action-button", on: { click: _vm.openAITools } },
            [
              _c("div", { staticClass: "material-icons" }, [
                _vm._v("emoji_objects"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "action-button",
              on: { click: _vm.openReadyContents },
            },
            [_c("ReadyContentsSvg")],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right-actions" },
          [
            _vm.emojiPicker
              ? _c("EmojiButton", {
                  attrs: { "on-emoji-picked": _vm.addEmojiToMessage },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "button",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "action-button send" }, [
                              _c("div", { staticClass: "material-icons" }, [
                                _vm._v("mood"),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    573047781
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.shareLocation && _vm.customerLocationEnabled
              ? _c("LocationShare", { on: { location: _vm.sendLocation } }, [
                  _c("div", { staticClass: "action-button" }, [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("location_on"),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.shareAttachment && _vm.agentFileSendEnabled
              ? _c(
                  "div",
                  {
                    staticClass: "action-button",
                    on: { click: _vm.choseFile },
                  },
                  [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("attachment"),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.agentVoiceRecordEnabled && (_vm.voiceRecording || _vm.isEmpty())
              ? _c(
                  "VoiceRecorder",
                  {
                    attrs: { cb: _vm.sendVoiceMessage },
                    on: {
                      recording: function ($event) {
                        _vm.voiceRecording = $event
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "action-button primary",
                        class: { send: _vm.voiceRecording },
                      },
                      [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v(_vm._s(_vm.voiceRecording ? "send" : "mic")),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.voiceRecording && !_vm.isEmpty()
              ? _c(
                  "div",
                  {
                    staticClass: "action-button primary send",
                    on: { click: _vm.submit },
                  },
                  [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("send"),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("editor-content", {
        ref: "editor",
        class: "editor",
        attrs: { editor: _vm.editor },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }